import ApplicationController from "./application_controller"
import TomSelect from "tom-select"
import "tom-select/dist/esm/plugins/dropdown_input/plugin"
import "tom-select/dist/css/tom-select.css"
import "../stylesheets/tom-select.scss"

function safeFaIcon(icon) {
  const s = String(icon || "").trim()
  return /^[a-z0-9-]+$/.test(s) ? s : "font"
}

export default class extends ApplicationController {
  static targets = ["input"]

  connect() {
    this.initTomSelect()
  }

  disconnect() {
    this.destroyTomSelect()
  }

  initTomSelect() {
    if (!this.hasInputTarget) return

    const placeholder =
      this.inputTarget.dataset.placeholder || this.inputTarget.getAttribute("placeholder") || ""

    const options = Array.from(this.inputTarget.options).map((option) => {
      let extra = {}
      try {
        const raw = option.dataset?.data
        if (raw) extra = JSON.parse(raw)
      } catch {
        extra = {}
      }
      return {
        value: option.value,
        text: option.text,
        icon: extra.icon,
        typeLabel: extra.typeLabel
      }
    })

    const noResultsText =
      this.inputTarget.dataset.noResults ||
      `Keine Ergebnisse. Mit Esc schließen.`

    this.tomselect = new TomSelect(this.inputTarget, {
      plugins: ["dropdown_input"],
      // Zellen-Wrapper nutzen overflow-hidden (df_seg) → Dropdown am body, sonst unsichtbar abgeschnitten
      dropdownParent: "body",
      // Eigene Klasse: Styles unter .dynamic-filter-field-ts greifen am body nicht mehr
      dropdownClass: "ts-dropdown ts-dropdown-dynamic-filter-body",
      persist: false,
      allowEmptyOption: true,
      create: false,
      placeholder,
      options,
      openOnFocus: true,
      closeAfterSelect: true,
      selectOnTab: true,
      maxOptions: 200,
      hideSelected: false,
      render: {
        no_results: (data, escape) =>
          `<div class="no-results px-2 py-2 text-xs text-gray-500">${escape(noResultsText)}: "${escape(data.input)}"</div>`,
        option: (data, escape) => {
          if (!data.value) {
            return `<div class="option px-2 py-2 text-xs text-gray-500">${escape(data.text)}</div>`
          }
          const ic = safeFaIcon(data.icon)
          const tl = escape(data.typeLabel || "")
          return (
            `<div class="option flex items-center gap-2 px-2 py-2 text-xs text-gray-800">` +
            `<i class="fas fa-${ic} w-4 shrink-0 text-center text-gray-500" aria-hidden="true"></i>` +
            `<span class="min-w-0 flex-1 truncate font-medium">${escape(data.text)}</span>` +
            `<span class="shrink-0 rounded bg-gray-100 px-2 py-0.5 text-xs font-normal leading-none text-gray-500">${tl}</span>` +
            `</div>`
          )
        },
        item: (data, escape) => {
          if (!data.value) {
            return (
              `<div class="item flex items-center gap-1.5 text-xs text-gray-500">` +
              `<i class="fas fa-filter w-3 shrink-0 text-center text-xs text-gray-400" aria-hidden="true"></i>` +
              `<span class="truncate">${escape(data.text)}</span>` +
              `</div>`
            )
          }
          const ic = safeFaIcon(data.icon)
          return (
            `<div class="item flex min-w-0 max-w-full items-center gap-1.5 text-xs text-gray-800">` +
            `<i class="fas fa-${ic} w-3 shrink-0 text-center text-xs text-gray-500" aria-hidden="true"></i>` +
            `<span class="truncate font-normal">${escape(data.text)}</span>` +
            `</div>`
          )
        }
      }
    })
  }

  destroyTomSelect() {
    if (this.tomselect) {
      this.tomselect.destroy()
      this.tomselect = null
    }
  }
}
